import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const kasirRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'kasir',
  component: lazyRouteComponent(() => import('./layout'), 'KasirLayout'),
});

const floorRoute = createRoute({
  getParentRoute: () => kasirRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./floor-page'), 'KasirFloorPage'),
});

export const kasirTableRoute = createRoute({
  getParentRoute: () => kasirRoute,
  path: 'meja/$tableId',
  component: lazyRouteComponent(() => import('./table-page'), 'KasirTablePage'),
});

const shiftRoute = createRoute({
  getParentRoute: () => kasirRoute,
  path: 'shift',
  component: lazyRouteComponent(() => import('./shift-page'), 'KasirShiftPage'),
});

const ordersRoute = createRoute({
  getParentRoute: () => kasirRoute,
  path: 'pesanan',
  component: lazyRouteComponent(() => import('./orders-page'), 'KasirOrdersPage'),
});

const orderRoute = createRoute({
  getParentRoute: () => kasirRoute,
  path: 'pesanan/$orderId',
  component: lazyRouteComponent(() => import('./order-page'), 'KasirOrderPage'),
});

const menuRoute = createRoute({
  getParentRoute: () => kasirRoute,
  path: 'menu',
  component: lazyRouteComponent(() => import('../../shared/menu/menu-page'), 'MenuPage'),
});

export const kasirTree = kasirRoute.addChildren([
  floorRoute,
  kasirTableRoute,
  ordersRoute,
  orderRoute,
  menuRoute,
  shiftRoute,
]);
